<template>
    <!-- Not Used -->
	<div class="page-layout simple hrmspayrollblock right-sidebar inner-sidebar">
		<div class="pb-6">
            <div id="mail" style="border-radius: 15px;border: solid 1px #94bef0;margin-right: 15px;margin-left: 15px;background-color: #00448b;margin-top: 10px;">
				<div class="content-section hrmspayrollblock-section" style="border-radius: 15px;background-color: #00448b;">
					<div class="center-section" style="background-color: #00448b;">
                        <div class="tabs pt-4">
                            <ul class="nav nav-tabs nav-info nav-info-icon" id="myTab" role="tablist">
                                <li class="nav-item nav-li">
                                    <a class="nav-link nav-info-a active" id="company-tab" data-toggle="tab" href="#companytab" role="tab"
                                    aria-controls="home" aria-expanded="true" style="border-radius: 30px;margin-right: 20px;">
                                        <span class="tabspan">Company Information</span>
                                    </a>
                                </li>
                                <li class="nav-item nav-li">
                                    <a class="nav-link nav-info-a" id="admin-tab" data-toggle="tab" href="#admintab" role="tab"
                                    aria-controls="profile" style="border-radius: 30px;"  @click="userModelView('userbasic')">
                                        <span class="tabspan">
                                            Admin Information
                                        </span>
                                    </a>
                                </li>
                            </ul>
                            <div class="tab-content py-6 px-1" id="myTabContent">
                                <div class="tab-pane fade show active" id="companytab" role="tabpanel" aria-labelledby="company-tab">
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="hrmspayroll-list">
                                                <div class="hrmspayroll-list-item" @click="companyModelView('companybasic')">
                                                    <div class="hrmspayroll-wrapper" v-bind:class="{ selected: companybasicinfo}">
                                                        <img class="hrmspayroll-images" src="/static/images/crm/basic.svg">
                                                    </div>
                                                    <div class="hrmspayroll-name">Basic Information</div>
                                                </div>
                                                <div class="hrmspayroll-list-item" @click="companyModelView('companycommunicationinfo')">
                                                    <div class="hrmspayroll-wrapper" v-bind:class="{ selected: communicationinfo}">
                                                        <img class="hrmspayroll-images" src="/static/images/crm/communication.svg">
                                                    </div>
                                                    <div class="hrmspayroll-name">Communication Information</div>
                                                </div>
                                                <div class="hrmspayroll-list-item" @click="companyModelView('companybranchinfo')">
                                                    <div class="hrmspayroll-wrapper" v-bind:class="{ selected: companybranchinfo}">
                                                        <img class="hrmspayroll-images" src="/static/images/crm/branches.svg">
                                                    </div>
                                                    <div class="hrmspayroll-name">Branches</div>
                                                </div>
                                                <div class="hrmspayroll-list-item" @click="companyModelView('companylocations')">
                                                    <div class="hrmspayroll-wrapper" v-bind:class="{ selected: companylocationsinfo}">
                                                        <img class="hrmspayroll-images" src="/static/images/crm/locations.svg">
                                                    </div>
                                                    <div class="hrmspayroll-name">Company Locations</div>
                                                </div>
                                                <div class="hrmspayroll-list-item" @click="companyModelView('companyqrcode')">
                                                    <div class="hrmspayroll-wrapper" v-bind:class="{ selected: companyqrcodeinfo}">
                                                        <img class="hrmspayroll-images" src="/static/images/crm/qrcode.svg">
                                                    </div>
                                                    <div class="hrmspayroll-name">QR - Code</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="tab-pane fade" id="admintab" role="tabpanel" aria-labelledby="admin-tab">
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="hrmspayroll-list">
                                                <div class="hrmspayroll-list-item" @click="userModelView('userbasic')">
                                                    <div class="hrmspayroll-wrapper" v-bind:class="{ selected: userbasicinfo}">
                                                        <img class="hrmspayroll-images" src="/static/images/crm/basic.svg">
                                                    </div>
                                                    <div class="hrmspayroll-name">Basic Information</div>
                                                </div>
                                                <div class="hrmspayroll-list-item" @click="userModelView('usercommunicationinfo')">
                                                    <div class="hrmspayroll-wrapper" v-bind:class="{ selected: communicationuserinfo}">
                                                        <img class="hrmspayroll-images" src="/static/images/crm/communication.svg">
                                                    </div>
                                                    <div class="hrmspayroll-name">Communication Information</div>
                                                </div>
                                                <div class="hrmspayroll-list-item" @click="userModelView('address')">
                                                    <div class="hrmspayroll-wrapper" v-bind:class="{ selected: addressinfo}">
                                                        <img class="hrmspayroll-images" src="/static/images/crm/address.svg">
                                                    </div>
                                                    <div class="hrmspayroll-name">Address</div>
                                                </div>
                                                <div class="hrmspayroll-list-item" @click="userModelView('preferences')">
                                                    <div class="hrmspayroll-wrapper" v-bind:class="{ selected: preferencesinfo}">
                                                        <img class="hrmspayroll-images" src="/static/images/crm/preferences.svg">
                                                    </div>
                                                    <div class="hrmspayroll-name">Preferences</div>
                                                </div>
                                                <div class="hrmspayroll-list-item" @click="userModelView('userqrcode')">
                                                    <div class="hrmspayroll-wrapper" v-bind:class="{ selected: userqrcodeinfo}">
                                                        <img class="hrmspayroll-images" src="/static/images/crm/qrcode.svg">
                                                    </div>
                                                    <div class="hrmspayroll-name">QR - Code</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
					</div>
					<div class="fuse-sidebar hrmspayroll-sidebar sidebar left-positioned open locked-open" style="border-radius: 15px;">
						<div class="preview-elements details-block">
                            <div class="hrmspayrollcard hrmspayroll-over-card mt-4 personal" v-if="companybasicinfo">
								<div class="hrmspayrollcard-body">
                                    <h6 class="heading-text pb-1 pt-2 text-secondary fs-16">
                                        Company Information
                                        <span style="float: right;margin-right: 3px;margin-top: -5px;">
                                            <a href="javascript:;" class="btn btn-danger button-sm" style="height: 28px;line-height: 28px;min-width: 5rem;box-shadow: none;border-radius: 5px !important;padding: 0px 12px;font-size: 12px;text-transform:capitalize;">
                                                <i class="icon-file-pdf" style="color: #fff;font-size:16px;width: 16px;height: 16px;line-height: 16px;"></i>
                                                PDF
                                            </a>
                                            <a href="javascript:;" class="btn btn-secondary button-sm" style="height: 28px;line-height: 28px;min-width: 5rem;box-shadow: none;border-radius: 5px !important;padding: 0px 12px;font-size: 12px;text-transform:capitalize;">
                                                <i class="icon-printer" style="color: #fff;font-size:16px;width: 16px;height: 16px;line-height: 16px;"></i>
                                                Print
                                            </a>
                                        </span>
                                    </h6>
                                    <div class="bordergrey" style="border: 1px solid #c6c6c6;border-radius: 18px;padding: 10px 15px;margin-bottom:15px;">
                                        <h6 class="header-invest pb-2">
                                            Basic Information
                                            <a href="javascript:;" class="btn btn-outline-secondary btn-smm pull-right" style="min-width: 5rem;">
                                                <i class="icon-pencil mr-1" style="color: #00448b;font-size:14px;width: 16px;height: 16px;line-height: 16px;"></i>
                                                Edit
                                            </a>
                                        </h6>
                                        <div class="blockdigi-section" style="background: transparent;padding-right: 30px">
                                            <div class="section-container a-Zm">
                                                <div class="sections-div transdiv">
                                                    <div class="content-divs hrmspayroll-divs">
                                                        <div class="content-left-sec hrmspayrolldesc">Company Name</div>
                                                        <div class="content-right-sec hrmspayroll-right-desc">
                                                            <span class="right-div">
                                                                DigiCollect Pvt Ltd
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="content-divs hrmspayroll-divs">
                                                        <div class="content-left-sec hrmspayrolldesc">Company Type</div>
                                                        <div class="content-right-sec hrmspayroll-right-desc">
                                                            <span class="right-div">
                                                                IT
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="content-divs hrmspayroll-divs">
                                                        <div class="content-left-sec hrmspayrolldesc">Domain Name</div>
                                                        <div class="content-right-sec hrmspayroll-right-desc">
                                                            <span class="right-div">
                                                                DigiCollect
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="content-divs hrmspayroll-divs">
                                                        <div class="content-left-sec hrmspayrolldesc">Date of Incorporation</div>
                                                        <div class="content-right-sec hrmspayroll-right-desc">
                                                            <span class="right-div">
                                                                22/10/2016
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="content-divs hrmspayroll-divs">
                                                        <div class="content-left-sec hrmspayrolldesc">Number of Employees</div>
                                                        <div class="content-right-sec hrmspayroll-right-desc">
                                                            <span class="right-div">
                                                                30+ Employees
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="hrmspayrollcard hrmspayroll-over-card mt-4 salary" v-if="communicationinfo">
								<div class="hrmspayrollcard-body">
                                    <h6 class="heading-text pb-1 pt-2 text-secondary fs-16">
                                        Company Information
                                        <span style="float: right;margin-right: 3px;margin-top: -5px;">
                                            <a href="javascript:;" class="btn btn-danger button-sm" style="height: 28px;line-height: 28px;min-width: 5rem;box-shadow: none;border-radius: 5px !important;padding: 0px 12px;font-size: 12px;text-transform:capitalize;">
                                                <i class="icon-file-pdf" style="color: #fff;font-size:16px;width: 16px;height: 16px;line-height: 16px;"></i>
                                                PDF
                                            </a>
                                            <a href="javascript:;" class="btn btn-secondary button-sm" style="height: 28px;line-height: 28px;min-width: 5rem;box-shadow: none;border-radius: 5px !important;padding: 0px 12px;font-size: 12px;text-transform:capitalize;">
                                                <i class="icon-printer" style="color: #fff;font-size:16px;width: 16px;height: 16px;line-height: 16px;"></i>
                                                Print
                                            </a>
                                        </span>
                                    </h6>
                                    <div class="bordergrey" style="border: 1px solid #c6c6c6;border-radius: 18px;padding: 10px 15px;margin-bottom:15px;">
                                        <h6 class="header-invest pb-2">
                                            Communication Information
                                            <a href="javascript:;" class="btn btn-outline-secondary btn-smm pull-right" style="min-width: 5rem;">
                                                <i class="icon-pencil mr-1" style="color: #00448b;font-size:14px;width: 16px;height: 16px;line-height: 16px;"></i>
                                                Edit
                                            </a>
                                        </h6>
                                        <div class="blockdigi-section" style="background: transparent;padding-right: 30px">
                                            <div class="section-container a-Zm">
                                                <div class="sections-div transdiv">
                                                    <div class="content-divs hrmspayroll-divs">
                                                        <div class="content-left-sec hrmspayrolldesc">Email</div>
                                                        <div class="content-right-sec hrmspayroll-right-desc">
                                                            <span class="right-div">
                                                                digicollect@gmail.com
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="content-divs hrmspayroll-divs">
                                                        <div class="content-left-sec hrmspayrolldesc">Website</div>
                                                        <div class="content-right-sec hrmspayroll-right-desc">
                                                            <span class="right-div">
                                                                www.digicollect.com
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="content-divs hrmspayroll-divs">
                                                        <div class="content-left-sec hrmspayrolldesc">Phone Number</div>
                                                        <div class="content-right-sec hrmspayroll-right-desc">
                                                            <span class="right-div">
                                                                +1.212.683.0400
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="content-divs hrmspayroll-divs">
                                                        <div class="content-left-sec hrmspayrolldesc">Mobile Number</div>
                                                        <div class="content-right-sec hrmspayroll-right-desc">
                                                            <span class="right-div">
                                                                +91 98450 98450
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <h6 class="header-invest pt-2 pb-2">
                                            Social Media Entities
                                        </h6>
                                        <a href="javascript:;" class="btn btn-outline-secondary btn-smm mb-3">
                                            <i class="icon-facebook mr-2" style="color: #00448b;font-size:16px;width: 16px;height: 16px;line-height: 16px;"></i>
                                            <i class="icon-twitter mr-2" style="color: #00448b;font-size:16px;width: 16px;height: 16px;line-height: 16px;"></i>
                                            <i class="icon-skype" style="color: #00448b;font-size:16px;width: 16px;height: 16px;line-height: 16px;"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div class="hrmspayrollcard hrmspayroll-over-card mt-4 overtime" v-if="companybranchinfo">
								<div class="hrmspayrollcard-body">
                                    <h6 class="heading-text pb-1 pt-2 text-secondary fs-16">
                                        Company Information
                                        <span style="float: right;margin-right: 3px;margin-top: -5px;">
                                            <a href="javascript:;" class="btn btn-danger button-sm" style="height: 28px;line-height: 28px;min-width: 5rem;box-shadow: none;border-radius: 5px !important;padding: 0px 12px;font-size: 12px;text-transform:capitalize;">
                                                <i class="icon-file-pdf" style="color: #fff;font-size:16px;width: 16px;height: 16px;line-height: 16px;"></i>
                                                PDF
                                            </a>
                                            <a href="javascript:;" class="btn btn-secondary button-sm" style="height: 28px;line-height: 28px;min-width: 5rem;box-shadow: none;border-radius: 5px !important;padding: 0px 12px;font-size: 12px;text-transform:capitalize;">
                                                <i class="icon-printer" style="color: #fff;font-size:16px;width: 16px;height: 16px;line-height: 16px;"></i>
                                                Print
                                            </a>
                                        </span>
                                    </h6>
                                    <div class="bordergrey" style="border: 1px solid #c6c6c6;border-radius: 18px;padding: 10px 15px;margin-bottom:15px;margin-top: 25px;">
                                        <h6 class="header-invest pb-2">
                                            Branches
                                            <a href="javascript:;" class="btn btn-outline-secondary btn-smm pull-right" style="min-width: 5rem;">
                                                <i class="icon-pencil mr-1" style="color: #00448b;font-size:14px;width: 16px;height: 16px;line-height: 16px;"></i>
                                                Edit
                                            </a>
                                        </h6>
                                        <el-collapse class="el-collapse-info" v-model="activeBranch">
                                            <el-collapse-item title="Branch 1" name="1">
                                                <div class="section-container a-Zm">
                                                    <div class="sections-div transdiv">
                                                        <div class="content-divs hrmspayroll-divs">
                                                            <div class="content-left-sec hrmspayrolldesc">Branch Code</div>
                                                            <div class="content-right-sec hrmspayroll-right-desc">
                                                                <span class="right-div">
                                                                    BBK
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div class="content-divs hrmspayroll-divs">
                                                            <div class="content-left-sec hrmspayrolldesc">Name</div>
                                                            <div class="content-right-sec hrmspayroll-right-desc">
                                                                <span class="right-div">
                                                                    DigiCollect Pvt Ltd
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div class="content-divs hrmspayroll-divs">
                                                            <div class="content-left-sec hrmspayrolldesc">Email</div>
                                                            <div class="content-right-sec hrmspayroll-right-desc">
                                                                <span class="right-div">
                                                                    digicollect@gmail.com
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div class="content-divs hrmspayroll-divs">
                                                            <div class="content-left-sec hrmspayrolldesc">Phone Number</div>
                                                            <div class="content-right-sec hrmspayroll-right-desc">
                                                                <span class="right-div">
                                                                    +1.212.683.0400
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div class="content-divs hrmspayroll-divs">
                                                            <div class="content-left-sec hrmspayrolldesc">Alternate Number</div>
                                                            <div class="content-right-sec hrmspayroll-right-desc">
                                                                <span class="right-div">
                                                                    +91 98450 98450
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <h6 class="padding: 5px 0px;" style="font-size: 14px;font-weight: 600;line-height: 1.2;letter-spacing: 0.1px;color: #4e5764;">
                                                            Address
                                                        </h6>
                                                        <div class="content-divs hrmspayroll-divs">
                                                            <div class="content-left-sec hrmspayrolldesc">Street</div>
                                                            <div class="content-right-sec hrmspayroll-right-desc">
                                                                <span class="right-div">
                                                                    4th Street
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div class="content-divs hrmspayroll-divs">
                                                            <div class="content-left-sec hrmspayrolldesc">Township</div>
                                                            <div class="content-right-sec hrmspayroll-right-desc">
                                                                <span class="right-div">
                                                                    Sampangi Rama Nagar
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div class="content-divs hrmspayroll-divs">
                                                            <div class="content-left-sec hrmspayrolldesc">City</div>
                                                            <div class="content-right-sec hrmspayroll-right-desc">
                                                                <span class="right-div">
                                                                    Bengaluru
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div class="content-divs hrmspayroll-divs">
                                                            <div class="content-left-sec hrmspayrolldesc">State</div>
                                                            <div class="content-right-sec hrmspayroll-right-desc">
                                                                <span class="right-div">
                                                                    Karnataka
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div class="content-divs hrmspayroll-divs">
                                                            <div class="content-left-sec hrmspayrolldesc">Zip Code</div>
                                                            <div class="content-right-sec hrmspayroll-right-desc">
                                                                <span class="right-div">
                                                                    560027
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div class="content-divs hrmspayroll-divs">
                                                            <div class="content-left-sec hrmspayrolldesc">Country</div>
                                                            <div class="content-right-sec hrmspayroll-right-desc">
                                                                <span class="right-div">
                                                                    India
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </el-collapse-item>
                                            <el-collapse-item title="Branch 2" name="2">
                                                <div class="section-container a-Zm">
                                                    <div class="sections-div transdiv">
                                                        <div class="content-divs hrmspayroll-divs">
                                                            <div class="content-left-sec hrmspayrolldesc">Branch Code</div>
                                                            <div class="content-right-sec hrmspayroll-right-desc">
                                                                <span class="right-div">
                                                                    BBK
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div class="content-divs hrmspayroll-divs">
                                                            <div class="content-left-sec hrmspayrolldesc">Name</div>
                                                            <div class="content-right-sec hrmspayroll-right-desc">
                                                                <span class="right-div">
                                                                    DigiCollect Pvt Ltd
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div class="content-divs hrmspayroll-divs">
                                                            <div class="content-left-sec hrmspayrolldesc">Email</div>
                                                            <div class="content-right-sec hrmspayroll-right-desc">
                                                                <span class="right-div">
                                                                    digicollect@gmail.com
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div class="content-divs hrmspayroll-divs">
                                                            <div class="content-left-sec hrmspayrolldesc">Phone Number</div>
                                                            <div class="content-right-sec hrmspayroll-right-desc">
                                                                <span class="right-div">
                                                                    +1.212.683.0400
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div class="content-divs hrmspayroll-divs">
                                                            <div class="content-left-sec hrmspayrolldesc">Alternate Number</div>
                                                            <div class="content-right-sec hrmspayroll-right-desc">
                                                                <span class="right-div">
                                                                    +91 98450 98450
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <h6 class="padding: 5px 0px;" style="font-size: 14px;font-weight: 600;line-height: 1.2;letter-spacing: 0.1px;color: #4e5764;">
                                                            Address
                                                        </h6>
                                                        <div class="content-divs hrmspayroll-divs">
                                                            <div class="content-left-sec hrmspayrolldesc">Street</div>
                                                            <div class="content-right-sec hrmspayroll-right-desc">
                                                                <span class="right-div">
                                                                    4th Street
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div class="content-divs hrmspayroll-divs">
                                                            <div class="content-left-sec hrmspayrolldesc">Township</div>
                                                            <div class="content-right-sec hrmspayroll-right-desc">
                                                                <span class="right-div">
                                                                    Sampangi Rama Nagar
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div class="content-divs hrmspayroll-divs">
                                                            <div class="content-left-sec hrmspayrolldesc">City</div>
                                                            <div class="content-right-sec hrmspayroll-right-desc">
                                                                <span class="right-div">
                                                                    Bengaluru
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div class="content-divs hrmspayroll-divs">
                                                            <div class="content-left-sec hrmspayrolldesc">State</div>
                                                            <div class="content-right-sec hrmspayroll-right-desc">
                                                                <span class="right-div">
                                                                    Karnataka
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div class="content-divs hrmspayroll-divs">
                                                            <div class="content-left-sec hrmspayrolldesc">Zip Code</div>
                                                            <div class="content-right-sec hrmspayroll-right-desc">
                                                                <span class="right-div">
                                                                    560027
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div class="content-divs hrmspayroll-divs">
                                                            <div class="content-left-sec hrmspayrolldesc">Country</div>
                                                            <div class="content-right-sec hrmspayroll-right-desc">
                                                                <span class="right-div">
                                                                    India
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </el-collapse-item>
                                            <el-collapse-item title="Branch 3" name="3">
                                                <div class="section-container a-Zm">
                                                    <div class="sections-div transdiv">
                                                        <div class="content-divs hrmspayroll-divs">
                                                            <div class="content-left-sec hrmspayrolldesc">Branch Code</div>
                                                            <div class="content-right-sec hrmspayroll-right-desc">
                                                                <span class="right-div">
                                                                    BBK
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div class="content-divs hrmspayroll-divs">
                                                            <div class="content-left-sec hrmspayrolldesc">Name</div>
                                                            <div class="content-right-sec hrmspayroll-right-desc">
                                                                <span class="right-div">
                                                                    DigiCollect Pvt Ltd
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div class="content-divs hrmspayroll-divs">
                                                            <div class="content-left-sec hrmspayrolldesc">Email</div>
                                                            <div class="content-right-sec hrmspayroll-right-desc">
                                                                <span class="right-div">
                                                                    digicollect@gmail.com
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div class="content-divs hrmspayroll-divs">
                                                            <div class="content-left-sec hrmspayrolldesc">Phone Number</div>
                                                            <div class="content-right-sec hrmspayroll-right-desc">
                                                                <span class="right-div">
                                                                    +1.212.683.0400
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div class="content-divs hrmspayroll-divs">
                                                            <div class="content-left-sec hrmspayrolldesc">Alternate Number</div>
                                                            <div class="content-right-sec hrmspayroll-right-desc">
                                                                <span class="right-div">
                                                                    +91 98450 98450
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <h6 class="padding: 5px 0px;" style="font-size: 14px;font-weight: 600;line-height: 1.2;letter-spacing: 0.1px;color: #4e5764;">
                                                            Address
                                                        </h6>
                                                        <div class="content-divs hrmspayroll-divs">
                                                            <div class="content-left-sec hrmspayrolldesc">Street</div>
                                                            <div class="content-right-sec hrmspayroll-right-desc">
                                                                <span class="right-div">
                                                                    4th Street
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div class="content-divs hrmspayroll-divs">
                                                            <div class="content-left-sec hrmspayrolldesc">Township</div>
                                                            <div class="content-right-sec hrmspayroll-right-desc">
                                                                <span class="right-div">
                                                                    Sampangi Rama Nagar
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div class="content-divs hrmspayroll-divs">
                                                            <div class="content-left-sec hrmspayrolldesc">City</div>
                                                            <div class="content-right-sec hrmspayroll-right-desc">
                                                                <span class="right-div">
                                                                    Bengaluru
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div class="content-divs hrmspayroll-divs">
                                                            <div class="content-left-sec hrmspayrolldesc">State</div>
                                                            <div class="content-right-sec hrmspayroll-right-desc">
                                                                <span class="right-div">
                                                                    Karnataka
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div class="content-divs hrmspayroll-divs">
                                                            <div class="content-left-sec hrmspayrolldesc">Zip Code</div>
                                                            <div class="content-right-sec hrmspayroll-right-desc">
                                                                <span class="right-div">
                                                                    560027
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div class="content-divs hrmspayroll-divs">
                                                            <div class="content-left-sec hrmspayrolldesc">Country</div>
                                                            <div class="content-right-sec hrmspayroll-right-desc">
                                                                <span class="right-div">
                                                                    India
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </el-collapse-item>
                                        </el-collapse>
                                    </div>
                                </div>
                            </div>

                            <div class="hrmspayrollcard hrmspayroll-over-card mt-4 bank" v-if="companylocationsinfo">
								<div class="hrmspayrollcard-body">
                                    <h6 class="heading-text pb-1 pt-2 text-secondary fs-16">
                                        Company Information
                                        <span style="float: right;margin-right: 3px;margin-top: -5px;">
                                            <a href="javascript:;" class="btn btn-danger button-sm" style="height: 28px;line-height: 28px;min-width: 5rem;box-shadow: none;border-radius: 5px !important;padding: 0px 12px;font-size: 12px;text-transform:capitalize;">
                                                <i class="icon-file-pdf" style="color: #fff;font-size:16px;width: 16px;height: 16px;line-height: 16px;"></i>
                                                PDF
                                            </a>
                                            <a href="javascript:;" class="btn btn-secondary button-sm" style="height: 28px;line-height: 28px;min-width: 5rem;box-shadow: none;border-radius: 5px !important;padding: 0px 12px;font-size: 12px;text-transform:capitalize;">
                                                <i class="icon-printer" style="color: #fff;font-size:16px;width: 16px;height: 16px;line-height: 16px;"></i>
                                                Print
                                            </a>
                                        </span>
                                    </h6>
                                    <div class="bordergrey" style="border: 1px solid #c6c6c6;border-radius: 18px;padding: 10px 15px;margin-bottom:15px;">
                                        <h6 class="header-invest pb-2">
                                            Company Locations
                                            <a href="javascript:;" class="btn btn-outline-secondary btn-smm pull-right" style="min-width: 5rem;">
                                                <i class="icon-pencil mr-1" style="color: #00448b;font-size:14px;width: 16px;height: 16px;line-height: 16px;"></i>
                                                Edit
                                            </a>
                                        </h6>
                                        <div class="blockdigi-section mt-8" style="background: transparent;">
                                            <!-- <img src="/static/images/mapimage.png" class="img-fluid" style="border-radius: 12px;"> -->
                                            <GmapMap :center="center" :zoom="3" map-type-id="roadmap"
                                            style="width: 100%; height: 250px" :options="{
                                            zoomControl: true,
                                            scrollwheel: false,
                                            panControl: true,
                                            mapTypeControl: false,
                                            scaleControl: false,
                                            streetViewControl: false,
                                            rotateControl: true,
                                            fullscreenControl: true,
                                            disableDefaultUi: false}"
                                            >
                                            <GmapInfoWindow  :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
                                                {{infoContent}}
                                            </GmapInfoWindow>
                                                <GmapMarker
                                                    :key="index"
                                                    v-for="(m, index) in markers"
                                                    :position="m.position"
                                                    :clickable="true"
                                                    :draggable="false"
                                                    @click="center=m.position"
                                                />
                                            </GmapMap>
                                            <div class="py-2 px-3 mt-3" style="background: #f5f6f9;border-radius: 10px;">
                                                <div class="text-center" style="width: 30px;height: 4px;display: block;background-color: #4e5764;margin: 0 auto;position: relative;border-radius: 12px;"></div>
                                                <div class="contactinfo flex-wrap flex-sm-nowrap row no-gutters align-items-center" style="cursor: default;border-bottom: 1px solid #d7d8da;">
                                                    <div class="col">
                                                        <span class="name h6">DigiCollect Pvt Ltd</span>
                                                        <p class="last-message text-truncate">Software Company</p>
                                                        <p class="last-message text-truncate">
                                                            <span class="text-green">Open Now :</span>
                                                            7 am - 8 pm
                                                        </p>
                                                    </div>
                                                    <div class="col-12 col-sm-auto d-flex flex-column align-items-start">
                                                        <div class="last-message-time">
                                                            <button class="btn btn-secondary btn-smm">
                                                                <i class="icon-directions"></i>
                                                                Directions
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="flex-wrap flex-sm-nowrap row no-gutters align-items-center" style="cursor: default;">
                                                    <div class="col">
                                                        <ul class="list-group list-group-address">
                                                            <li class="list-group-item">
                                                                <div class="avatar">
                                                                    <img src="/static/images/images-new-theme/icons/marker.svg">
                                                                </div>
                                                                <div class="list-item-content">
                                                                    4th Main Road, Sampangi Rama Nagar, Bengaluru,<br> Karnataka,
                                                                    Pincode-560027
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="hrmspayrollcard hrmspayroll-over-card mt-4 inves" v-if="companyqrcodeinfo">
								<div class="hrmspayrollcard-body">
                                    <h6 class="heading-text pb-1 pt-2 text-secondary fs-16">
                                        Company Information
                                        <span style="float: right;margin-right: 3px;margin-top: -5px;">
                                            <a href="javascript:;" class="btn btn-danger button-sm" style="height: 28px;line-height: 28px;min-width: 5rem;box-shadow: none;border-radius: 5px !important;padding: 0px 12px;font-size: 12px;text-transform:capitalize;">
                                                <i class="icon-file-pdf" style="color: #fff;font-size:16px;width: 16px;height: 16px;line-height: 16px;"></i>
                                                PDF
                                            </a>
                                            <a href="javascript:;" class="btn btn-secondary button-sm" style="height: 28px;line-height: 28px;min-width: 5rem;box-shadow: none;border-radius: 5px !important;padding: 0px 12px;font-size: 12px;text-transform:capitalize;">
                                                <i class="icon-printer" style="color: #fff;font-size:16px;width: 16px;height: 16px;line-height: 16px;"></i>
                                                Print
                                            </a>
                                        </span>
                                    </h6>
                                    <div class="bordergrey" style="border: 1px solid #c6c6c6;border-radius: 18px;padding: 10px 15px;margin-bottom:15px;">
                                        <h6 class="header-invest pb-2">
                                            Company QR-Code
                                            <a href="javascript:;" class="btn btn-outline-secondary btn-smm pull-right" style="min-width: 5rem;">
                                                <i class="icon-pencil mr-1" style="color: #00448b;font-size:14px;width: 16px;height: 16px;line-height: 16px;"></i>
                                                Edit
                                            </a>
                                        </h6>
                                        <div class="blockdigi-section mt-4" style="background: transparent;">
                                            <div class="contacts-list-header text-center mb-3" style="border-bottom: 0px solid #transparent !important;">
                                                <div class="qrcode-info-block mt-2">
                                                    <img src="/static/images/qr-logo-dg.svg" class="qr-info-logo">
                                                    <qrcode-vue :value="valueqrinfo" :size="size" level="H" background="" foreground="#00448b" class="qrcode-info-content"></qrcode-vue>
                                                </div>
                                                <div class="mt-5">
                                                    <div class="scan-label mt-12 mr-20" style="color: #4e5764;font-size:16px;">Scan QR Code</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="hrmspayrollcard hrmspayroll-over-card mt-4 dedu" v-if="userbasicinfo">
								<div class="hrmspayrollcard-body">
                                    <h6 class="heading-text pb-1 pt-2 text-secondary fs-16">
                                        Admin Information
                                        <span style="float: right;margin-right: 3px;margin-top: -5px;">
                                            <a href="javascript:;" class="btn btn-danger button-sm" style="height: 28px;line-height: 28px;min-width: 5rem;box-shadow: none;border-radius: 5px !important;padding: 0px 12px;font-size: 12px;text-transform:capitalize;">
                                                <i class="icon-file-pdf" style="color: #fff;font-size:16px;width: 16px;height: 16px;line-height: 16px;"></i>
                                                PDF
                                            </a>
                                            <a href="javascript:;" class="btn btn-secondary button-sm" style="height: 28px;line-height: 28px;min-width: 5rem;box-shadow: none;border-radius: 5px !important;padding: 0px 12px;font-size: 12px;text-transform:capitalize;">
                                                <i class="icon-printer" style="color: #fff;font-size:16px;width: 16px;height: 16px;line-height: 16px;"></i>
                                                Print
                                            </a>
                                        </span>
                                    </h6>
                                    <div class="bordergrey" style="border: 1px solid #c6c6c6;border-radius: 18px;padding: 10px 15px;margin-bottom:15px;">
                                        <h6 class="header-invest pb-2">
                                            Basic Information
                                            <a href="javascript:;" class="btn btn-outline-secondary btn-smm pull-right" style="min-width: 5rem;">
                                                <i class="icon-pencil mr-1" style="color: #00448b;font-size:14px;width: 16px;height: 16px;line-height: 16px;"></i>
                                                Edit
                                            </a>
                                        </h6>
                                        <div class="blockdigi-section" style="background: transparent;padding-right: 30px">
                                            <div class="section-container a-Zm">
                                                <div class="sections-div transdiv">
                                                    <div class="content-divs hrmspayroll-divs">
                                                        <div class="content-left-sec hrmspayrolldesc">First Name</div>
                                                        <div class="content-right-sec hrmspayroll-right-desc">
                                                            <span class="right-div">
                                                                Hellix
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="content-divs hrmspayroll-divs">
                                                        <div class="content-left-sec hrmspayrolldesc">Last Name</div>
                                                        <div class="content-right-sec hrmspayroll-right-desc">
                                                            <span class="right-div">
                                                                Ocean
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="content-divs hrmspayroll-divs">
                                                        <div class="content-left-sec hrmspayrolldesc">Gender</div>
                                                        <div class="content-right-sec hrmspayroll-right-desc">
                                                            <span class="right-div">
                                                                Male
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="content-divs hrmspayroll-divs">
                                                        <div class="content-left-sec hrmspayrolldesc">Blood Group</div>
                                                        <div class="content-right-sec hrmspayroll-right-desc">
                                                            <span class="right-div">
                                                                O <sup class="ml-1">+</sup>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="content-divs hrmspayroll-divs">
                                                        <div class="content-left-sec hrmspayrolldesc">Medical Emergency Notes</div>
                                                        <div class="content-right-sec hrmspayroll-right-desc">
                                                            <span class="right-div">
                                                                Medical Emergency Notes
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="content-divs hrmspayroll-divs">
                                                        <div class="content-left-sec hrmspayrolldesc">Notes</div>
                                                        <div class="content-right-sec hrmspayroll-right-desc">
                                                            <span class="right-div">
                                                                Hygienic
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="hrmspayrollcard hrmspayroll-over-card mt-4 loans" v-if="communicationuserinfo">
								<div class="hrmspayrollcard-body">
                                    <h6 class="heading-text pb-1 pt-2 text-secondary fs-16">
                                        Admin Information
                                        <span style="float: right;margin-right: 3px;margin-top: -5px;">
                                            <a href="javascript:;" class="btn btn-danger button-sm" style="height: 28px;line-height: 28px;min-width: 5rem;box-shadow: none;border-radius: 5px !important;padding: 0px 12px;font-size: 12px;text-transform:capitalize;">
                                                <i class="icon-file-pdf" style="color: #fff;font-size:16px;width: 16px;height: 16px;line-height: 16px;"></i>
                                                PDF
                                            </a>
                                            <a href="javascript:;" class="btn btn-secondary button-sm" style="height: 28px;line-height: 28px;min-width: 5rem;box-shadow: none;border-radius: 5px !important;padding: 0px 12px;font-size: 12px;text-transform:capitalize;">
                                                <i class="icon-printer" style="color: #fff;font-size:16px;width: 16px;height: 16px;line-height: 16px;"></i>
                                                Print
                                            </a>
                                        </span>
                                    </h6>
                                    <div class="bordergrey" style="border: 1px solid #c6c6c6;border-radius: 18px;padding: 10px 15px;margin-bottom:15px;">
                                        <h6 class="header-invest pb-2">
                                            Communication Information
                                            <a href="javascript:;" class="btn btn-outline-secondary btn-smm pull-right" style="min-width: 5rem;">
                                                <i class="icon-pencil mr-1" style="color: #00448b;font-size:14px;width: 16px;height: 16px;line-height: 16px;"></i>
                                                Edit
                                            </a>
                                        </h6>
                                        <div class="blockdigi-section" style="background: transparent;padding-right: 30px">
                                            <div class="section-container a-Zm">
                                                <div class="sections-div transdiv">
                                                    <div class="content-divs hrmspayroll-divs">
                                                        <div class="content-left-sec hrmspayrolldesc">Personal Email</div>
                                                        <div class="content-right-sec hrmspayroll-right-desc">
                                                            <span class="right-div">
                                                                hellix@gmail.com
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="content-divs hrmspayroll-divs">
                                                        <div class="content-left-sec hrmspayrolldesc">Work Email</div>
                                                        <div class="content-right-sec hrmspayroll-right-desc">
                                                            <span class="right-div">
                                                                hellixocean@digicollect.com
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="content-divs hrmspayroll-divs">
                                                        <div class="content-left-sec hrmspayrolldesc">Mobile Number</div>
                                                        <div class="content-right-sec hrmspayroll-right-desc">
                                                            <span class="right-div">
                                                                9942353678
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="content-divs hrmspayroll-divs">
                                                        <div class="content-left-sec hrmspayrolldesc">Work Number</div>
                                                        <div class="content-right-sec hrmspayroll-right-desc">
                                                            <span class="right-div">
                                                                9963748398
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="content-divs hrmspayroll-divs">
                                                        <div class="content-left-sec hrmspayrolldesc">Home Number</div>
                                                        <div class="content-right-sec hrmspayroll-right-desc">
                                                            <span class="right-div">
                                                                04322268462
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="content-divs hrmspayroll-divs">
                                                        <div class="content-left-sec hrmspayrolldesc">Emergency Contact Name</div>
                                                        <div class="content-right-sec hrmspayroll-right-desc">
                                                            <span class="right-div">
                                                                Charlie
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="content-divs hrmspayroll-divs">
                                                        <div class="content-left-sec hrmspayrolldesc">Emergency Contact Number</div>
                                                        <div class="content-right-sec hrmspayroll-right-desc">
                                                            <span class="right-div">
                                                                9384763782
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="hrmspayrollcard hrmspayroll-over-card mt-4 tax" v-if="addressinfo">
								<div class="hrmspayrollcard-body">
                                    <h6 class="heading-text pb-1 pt-2 text-secondary fs-16">
                                        Admin Information
                                        <span style="float: right;margin-right: 3px;margin-top: -5px;">
                                            <a href="javascript:;" class="btn btn-danger button-sm" style="height: 28px;line-height: 28px;min-width: 5rem;box-shadow: none;border-radius: 5px !important;padding: 0px 12px;font-size: 12px;text-transform:capitalize;">
                                                <i class="icon-file-pdf" style="color: #fff;font-size:16px;width: 16px;height: 16px;line-height: 16px;"></i>
                                                PDF
                                            </a>
                                            <a href="javascript:;" class="btn btn-secondary button-sm" style="height: 28px;line-height: 28px;min-width: 5rem;box-shadow: none;border-radius: 5px !important;padding: 0px 12px;font-size: 12px;text-transform:capitalize;">
                                                <i class="icon-printer" style="color: #fff;font-size:16px;width: 16px;height: 16px;line-height: 16px;"></i>
                                                Print
                                            </a>
                                        </span>
                                    </h6>
                                    <div class="bordergrey" style="border: 1px solid #c6c6c6;border-radius: 18px;padding: 10px 15px;margin-bottom:15px;">
                                        <h6 class="header-invest pb-2">
                                            Address
                                            <a href="javascript:;" class="btn btn-outline-secondary btn-smm pull-right" style="min-width: 5rem;">
                                                <i class="icon-pencil mr-1" style="color: #00448b;font-size:14px;width: 16px;height: 16px;line-height: 16px;"></i>
                                                Edit
                                            </a>
                                        </h6>
                                        <div class="blockdigi-section" style="background: transparent;border-bottom: 1px solid #d7d8da;">
                                            <div class="section-container a-Zm">
                                                <div class="sections-div transdiv">
                                                    <div class="content-divs hrmspayroll-divs">
                                                        <div class="content-left-sec hrmspayrolldesc">Street</div>
                                                        <div class="content-right-sec hrmspayroll-right-desc">
                                                            <span class="right-div">
                                                                4th Street
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="content-divs hrmspayroll-divs">
                                                        <div class="content-left-sec hrmspayrolldesc">Township</div>
                                                        <div class="content-right-sec hrmspayroll-right-desc">
                                                            <span class="right-div">
                                                                Sampangi Rama Nagar
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="content-divs hrmspayroll-divs">
                                                        <div class="content-left-sec hrmspayrolldesc">Zip Code</div>
                                                        <div class="content-right-sec hrmspayroll-right-desc">
                                                            <span class="right-div">
                                                                560027
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="content-divs hrmspayroll-divs">
                                                        <div class="content-left-sec hrmspayrolldesc">City</div>
                                                        <div class="content-right-sec hrmspayroll-right-desc">
                                                            <span class="right-div">
                                                                Bengaluru
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="content-divs hrmspayroll-divs">
                                                        <div class="content-left-sec hrmspayrolldesc">State</div>
                                                        <div class="content-right-sec hrmspayroll-right-desc">
                                                            <span class="right-div">
                                                                Karnataka
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="content-divs hrmspayroll-divs">
                                                        <div class="content-left-sec hrmspayrolldesc">Country</div>
                                                        <div class="content-right-sec hrmspayroll-right-desc">
                                                            <span class="right-div">
                                                                India
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="blockdigi-section mt-8" style="background: transparent;">
                                            <!-- <img src="/static/images/mapimage.png" class="img-fluid" style="border-radius: 12px;"> -->
                                            <GmapMap :center="center" :zoom="3" map-type-id="roadmap"
                                            style="width: 100%; height: 250px" :options="{
                                            zoomControl: true,
                                            scrollwheel: false,
                                            panControl: true,
                                            mapTypeControl: false,
                                            scaleControl: false,
                                            streetViewControl: false,
                                            rotateControl: true,
                                            fullscreenControl: true,
                                            disableDefaultUi: false}"
                                            >
                                            <GmapInfoWindow  :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
                                                {{infoContent}}
                                            </GmapInfoWindow>
                                                <GmapMarker
                                                    :key="index"
                                                    v-for="(m, index) in markers"
                                                    :position="m.position"
                                                    :clickable="true"
                                                    :draggable="false"
                                                    @click="center=m.position"
                                                />
                                            </GmapMap>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="hrmspayrollcard hrmspayroll-over-card mt-4 terminate" v-if="preferencesinfo">
								<div class="hrmspayrollcard-body">
                                    <h6 class="heading-text pb-1 pt-2 text-secondary fs-16">
                                        Admin Information
                                        <span style="float: right;margin-right: 3px;margin-top: -5px;">
                                            <a href="javascript:;" class="btn btn-danger button-sm" style="height: 28px;line-height: 28px;min-width: 5rem;box-shadow: none;border-radius: 5px !important;padding: 0px 12px;font-size: 12px;text-transform:capitalize;">
                                                <i class="icon-file-pdf" style="color: #fff;font-size:16px;width: 16px;height: 16px;line-height: 16px;"></i>
                                                PDF
                                            </a>
                                            <a href="javascript:;" class="btn btn-secondary button-sm" style="height: 28px;line-height: 28px;min-width: 5rem;box-shadow: none;border-radius: 5px !important;padding: 0px 12px;font-size: 12px;text-transform:capitalize;">
                                                <i class="icon-printer" style="color: #fff;font-size:16px;width: 16px;height: 16px;line-height: 16px;"></i>
                                                Print
                                            </a>
                                        </span>
                                    </h6>
                                    <div class="bordergrey" style="border: 1px solid #c6c6c6;border-radius: 18px;padding: 10px 15px;margin-bottom:15px;">
                                        <h6 class="header-invest pb-2">
                                            Preferences
                                            <a href="javascript:;" class="btn btn-outline-secondary btn-smm pull-right" style="min-width: 5rem;">
                                                <i class="icon-pencil mr-1" style="color: #00448b;font-size:14px;width: 16px;height: 16px;line-height: 16px;"></i>
                                                Edit
                                            </a>
                                        </h6>
                                        <div class="blockdigi-section" style="background: transparent;padding-right: 30px">
                                            <div class="section-container a-Zm">
                                                <div class="sections-div transdiv">
                                                    <h6 class="padding: 5px 0px;" style="font-size: 14px;font-weight: 600;line-height: 1.2;letter-spacing: 0.1px;color: #00448b;">
                                                        Food Preferences
                                                    </h6>
                                                    <div class="content-divs hrmspayroll-divs">
                                                        <div class="content-left-sec hrmspayrolldesc">Favourite Food</div>
                                                        <div class="content-right-sec hrmspayroll-right-desc">
                                                            <span class="right-div">
                                                                Mexican cheese Burger
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="content-divs hrmspayroll-divs">
                                                        <div class="content-left-sec hrmspayrolldesc">Favourite Drink</div>
                                                        <div class="content-right-sec hrmspayroll-right-desc">
                                                            <span class="right-div">
                                                                Red Wine
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="content-divs hrmspayroll-divs">
                                                        <div class="content-left-sec hrmspayrolldesc">Food Allergy</div>
                                                        <div class="content-right-sec hrmspayroll-right-desc">
                                                            <span class="right-div">
                                                                All Spicy Foods
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <h6 class="padding: 5px 0px;" style="font-size: 14px;font-weight: 600;line-height: 1.2;letter-spacing: 0.1px;color: #00448b;">
                                                        Room Preferences
                                                    </h6>
                                                    <div class="content-divs hrmspayroll-divs">
                                                        <div class="content-left-sec hrmspayrolldesc">Room Type</div>
                                                        <div class="content-right-sec hrmspayroll-right-desc">
                                                            <span class="right-div">
                                                                Normal
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="content-divs hrmspayroll-divs">
                                                        <div class="content-left-sec hrmspayrolldesc">Bed Type</div>
                                                        <div class="content-right-sec hrmspayroll-right-desc">
                                                            <span class="right-div">
                                                                Hard
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="content-divs hrmspayroll-divs">
                                                        <div class="content-left-sec hrmspayrolldesc">Pillow Type</div>
                                                        <div class="content-right-sec hrmspayroll-right-desc">
                                                            <span class="right-div">
                                                                Super Soft
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="content-divs hrmspayroll-divs">
                                                        <div class="content-left-sec hrmspayrolldesc">Bed Sheet Type</div>
                                                        <div class="content-right-sec hrmspayroll-right-desc">
                                                            <span class="right-div">
                                                                Cotton
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="hrmspayrollcard hrmspayroll-over-card mt-4 terminate" v-if="userqrcodeinfo">
								<div class="hrmspayrollcard-body">
                                    <h6 class="heading-text pb-1 pt-2 text-secondary fs-16">
                                        Admin Information
                                        <span style="float: right;margin-right: 3px;margin-top: -5px;">
                                            <a href="javascript:;" class="btn btn-danger button-sm" style="height: 28px;line-height: 28px;min-width: 5rem;box-shadow: none;border-radius: 5px !important;padding: 0px 12px;font-size: 12px;text-transform:capitalize;">
                                                <i class="icon-file-pdf" style="color: #fff;font-size:16px;width: 16px;height: 16px;line-height: 16px;"></i>
                                                PDF
                                            </a>
                                            <a href="javascript:;" class="btn btn-secondary button-sm" style="height: 28px;line-height: 28px;min-width: 5rem;box-shadow: none;border-radius: 5px !important;padding: 0px 12px;font-size: 12px;text-transform:capitalize;">
                                                <i class="icon-printer" style="color: #fff;font-size:16px;width: 16px;height: 16px;line-height: 16px;"></i>
                                                Print
                                            </a>
                                        </span>
                                    </h6>
                                    <div class="bordergrey" style="border: 1px solid #c6c6c6;border-radius: 18px;padding: 10px 15px;margin-bottom:15px;">
                                        <h6 class="header-invest pb-2">
                                            Admin QR-Code
                                            <a href="javascript:;" class="btn btn-outline-secondary btn-smm pull-right" style="min-width: 5rem;">
                                                <i class="icon-pencil mr-1" style="color: #00448b;font-size:14px;width: 16px;height: 16px;line-height: 16px;"></i>
                                                Edit
                                            </a>
                                        </h6>
                                        <div class="blockdigi-section mt-4" style="background: transparent;">
                                            <div class="contacts-list-header text-center mb-3" style="border-bottom: 0px solid #transparent !important;">
                                                <div class="qrcode-info-block mt-2">
                                                    <img src="/static/images/qr-logo-dg.svg" class="qr-info-logo">
                                                    <qrcode-vue :value="adminqrinfo" :size="sizeadmin" level="H" foreground="#00448b" class="qrcode-info-content"></qrcode-vue>
                                                </div>
                                                <div class="mt-5">
                                                    <div class="scan-label mt-12 mr-20" style="color: #4e5764;font-size:16px;">Scan QR Code</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import vSelect from 'vue-select'
import DatePicker from 'vue2-datepicker'
import QrcodeVue from 'qrcode.vue';

export default {
    data() {
        return {
            businessselect: '',
            value8: '',
            companybasicinfo: false,
            communicationinfo: false,
            companybranchinfo: false,
            companylocationsinfo: false,
            companyqrcodeinfo: false,
            userbasicinfo: false,
            communicationuserinfo: false,
            addressinfo: false,
            preferencesinfo: false,
            userqrcodeinfo: false,
            activeBranch: ['1'],
            center: {
                lat: 28.033886,
                lng: 1.659626
            },
            infoContent: '',
            infoWindowPos: null,
            infoWinOpen: true,
            currentMidx: null,
            //optional: offset infowindow so it visually sits nicely on top of our marker
            infoOptions: {
                pixelOffset: {
                    width: 0,
                    height: -35
                }
            },
            markers:
            [{
                position: {
                    lat: 40.745372,
                    lng: -73.982107
                },
                infoText: '1185 Avenue of the Americas, 3rd Floor New York, NY 10036 USA'
                },{
                position: {
                    lat: 12.967748,
                    lng: 77.593412
                },
                infoText: 'No. 40, Raja Rammohan Roy Road, Opposite Sree Kanteerava Stadium, Bangalore 560 027'
            }],
            valueqrinfo: 'https://example.com',
            adminqrinfo: "https://example.com",
            size: 165,
            sizeadmin: 165,
        }
    },
    components: {
        vSelect, DatePicker, QrcodeVue
    },
    methods: {
        employeeInfo() {
            this.$router.push({
                path: "/employeeinfo"
            });
        },
        createEarnings() {
            this.$router.push({
                path: "/createearnings"
            });
        },
        formatDate () {
            // you could also provide your own month names array
            const months = this.$refs.datePickerDigi.translation.months
            return `${months[this.$refs.datePickerDigi.getMonth()]} ${this.$refs.datePickerDigi.getFullYear()}`
        },
        companyModelView(viewName){
            switch( viewName){

            case 'companybasic':
                this.companybasicinfo=true;
                this.communicationinfo=false;
                this.companybranchinfo=false;
                this.companylocationsinfo=false;
                this.companyqrcodeinfo=false;
                break;
            case 'companycommunicationinfo':
                this.companybasicinfo=false;
                this.communicationinfo=true;
                this.companybranchinfo=false;
                this.companylocationsinfo=false;
                this.companyqrcodeinfo=false;
                break;
            case 'companybranchinfo':
                this.companybasicinfo=false;
                this.communicationinfo=false;
                this.companybranchinfo=true;
                this.companylocationsinfo=false;
                this.companyqrcodeinfo=false;
                break;
            case 'companylocations':
                this.companybasicinfo=false;
                this.communicationinfo=false;
                this.companybranchinfo=false;
                this.companylocationsinfo=true;
                this.companyqrcodeinfo=false;
                break;
            case 'companyqrcode':
                this.companybasicinfo=false;
                this.communicationinfo=false;
                this.companybranchinfo=false;
                this.companylocationsinfo=false;
                this.companyqrcodeinfo=true;
                break;
            }
        },
        userModelView(viewInfo){
            switch( viewInfo){
            case 'userbasic':
                this.userbasicinfo=true;
                this.communicationuserinfo=false;
                this.addressinfo=false;
                this.preferencesinfo=false;
                this.userqrcodeinfo=false;
                break;
            case 'usercommunicationinfo':
                this.userbasicinfo=false;
                this.communicationuserinfo=true;
                this.addressinfo=false;
                this.preferencesinfo=false;
                this.userqrcodeinfo=false;
                break;
            case 'address':
                this.userbasicinfo=false;
                this.communicationuserinfo=false;
                this.addressinfo=true;
                this.preferencesinfo=false;
                this.userqrcodeinfo=false;
                break;
            case 'preferences':
                this.userbasicinfo=false;
                this.communicationuserinfo=false;
                this.addressinfo=false;
                this.preferencesinfo=true;
                this.userqrcodeinfo=false;
                break;
            case 'userqrcode':
                this.userbasicinfo=false;
                this.communicationuserinfo=false;
                this.addressinfo=false;
                this.preferencesinfo=false;
                this.userqrcodeinfo=true;
                break;
            }
        },

        toggleInfoWindow: function(marker, idx) {
            this.infoWindowPos = marker.position;
            this.infoContent = marker.infoText;
            //check if its the same marker that was selected if yes toggle
            if (this.currentMidx == idx) {
              this.infoWinOpen = !this.infoWinOpen;
            }
            //if different marker set infowindow to open and reset current marker index
            else {
              this.infoWinOpen = true;
              this.currentMidx = idx;
            }
        }
    },
    created(){
        this.companyModelView('companybasic');
        this.userModelView('userbasic');
    }
}
</script>
<style>
.page-layout.simple.hrmspayrollblock {
    display: flex;
    flex-direction: column;
    flex: 1 0 auto;
    width: 100%;
    min-width: 100%;
}
.page-layout.simple.hrmspayrollblock.right-sidebar.inner-sidebar {
    flex-direction: column;
    overflow: hidden;
    height: 100%;
}
.content-section.hrmspayrollblock-section {
    display: flex;
    min-height: 0;
}

.fuse-sidebar.hrmspayroll-sidebar {
    display: flex;
    flex-direction: column;
    flex: 1 0 auto;
    top: 0;
    bottom: 0;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    width: 450px;
    min-width: 450px;
    max-width: 450px;
    z-index: 1000;
}
.fuse-sidebar.hrmspayroll-sidebar.left-positioned {
    right: 0;
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
}
.page-layout.simple.hrmspayrollblock.right-sidebar.inner-sidebar .content-section.hrmspayrollblock-section .sidebar.locked-open {
	background: #fff;
    padding-left: 10px;
    padding-right: 10px;
    box-shadow: none;
    border: 2px solid #00448b;
}
.page-layout.simple.hrmspayrollblock.right-sidebar.inner-sidebar .content-section.hrmspayrollblock-section .sidebar {
    order: 2;
    overflow-y: visible;
    overflow-x: visible;
}
.fuse-sidebar.hrmspayroll-sidebar.locked-open {
    position: relative!important;
    -webkit-transform: translateX(0)!important;
    transform: translateX(0)!important;
}
.page-layout.simple.hrmspayrollblock.right-sidebar.inner-sidebar .content-section.hrmspayrollblock-section .center-section {
    order: 1;
    padding: 10px 20px;
    background-color: #00448b;
    border-radius: 15px 0px 0px 15px;
}
.page-layout.simple.hrmspayrollblock.left-sidebar.inner-sidebar .content-section.hrmspayrollblock-section .center-section,
.page-layout.simple.hrmspayrollblock.right-sidebar.inner-sidebar .content-section.hrmspayrollblock-section .center-section {
    flex: 1 1 auto;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
}
.contactinfo {
    min-height: 8.8rem;
}
.contactinfo span.name {
    font-size: 16px;
    font-weight: 600;
    line-height: 1.22;
    letter-spacing: 0.12px;
    color: #4e5764;
}
.avatar-wrapper-contactinfo {
    position: relative;
    border: 1px solid #fff;
    border-radius: 50%;
    width: 60px;
    height: 60px;
    line-height: 56px;
    min-width: 60px;
    text-align: center;
    margin: 0 auto;
}
.avatar-wrapper-contactinfo .avatar {
    width: 50px;
    height: 50px;
    line-height: 50px;
    min-width: 50px;
    -webkit-border-radius: 50%;
    border-radius: 50%;
    font-size: 24px;
    font-weight: 500;
    text-align: center;
    color: #FFFFFF;
    background-color: #e0e3e6;
}
.contactinfo .last-message {
    max-width: 180px;
    margin-bottom: 0;
    font-weight: 500;
    color: #4e5764;
}
.contactinfo .last-message-time {
    white-space: nowrap;
    font-size: 15px;
    font-weight: 600;
    color: #4e5764;
}
.contactinfo .unread-message-count {
    color: #4e5764;
    font-size: 15px;
    font-weight: 600;
}
.hrmspayroll-list {
    flex-flow: row wrap;
    box-sizing: border-box;
    display: flex;
    place-content: start;
    align-items: center;
    flex: 0 0 auto;
    padding: 15px 0;
    max-height: none!important;
}
.hrmspayroll-list-item {
    flex-direction: column;
    box-sizing: border-box;
    display: flex;
    place-content: flex-start;
    align-items: center;
    min-width: 200px;
    min-height: 150px;
    width: 200px;
    height: 150px;
    padding: 10px 0;
    margin: 8px 16px;
    border-radius: 8px;
    cursor: pointer;
}
.hrmspayroll-list-item .hrmspayroll-wrapper {
    font-size: 100px!important;
    width: 100px!important;
    height: 100px!important;
    min-width: 100px!important;
    min-height: 100px!important;
    line-height: 70px!important;
    text-align: center;
}
.hrmspayroll-list-item .hrmspayroll-wrapper.selected {
    border: 1px solid #fff;
    border-radius: 27px;
}
.hrmspayroll-list-item img.hrmspayroll-images {
    font-size: 85px!important;
    width: 85px!important;
    height: 85px!important;
    min-width: 85px!important;
    min-height: 85px!important;
    line-height: 85px!important;
    display: inline-block;
}
.hrmspayroll-name {
    padding: 8px 5px 0;
    font-weight: 600;
    font-size: 14px;
    text-align: center;
    color: #fff;
}
.list-group .list-group-item>.avatar.avatarbank {
    -webkit-border-radius: 10px;
    border-radius: 10px;
}
.list-group .list-group-item>.avatar.avatarbank>img {
    max-width: 110px;
    max-height: 70px;
}
.terminate-buttons {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 15px;
}
.terminate-left, .terminate-right {
    float: none !important;
}
.mx-datepicker.mx-datepicker-range.noshortcuts > .mx-datepicker-popup .mx-shortcuts-wrapper {
    display: none !important;
}
.tabs>.nav.nav-tabs.nav-info.nav-info-icon {
    border: none;
    color: #fff;
    border-radius: 0;
}
.nav-tabs .nav-link.nav-info-a {
    overflow: visible !important;
    color: #ffffff !important;
    border: 1px solid #fff !important;
    padding: 0px 15px !important;
    display: block !important;
    height: 40px !important;
    line-height: 40px !important;
}
.nav-tabs.nav-info .nav-link.nav-info-a.active, .nav-tabs.nav-info .nav-item.show .nav-link {
    border-radius: 30px;
    color: #00448b !important;
    background: #fff;
    border-color: transparent !important;
}
.nav-link.nav-info-a>span {
    padding-left: 5px !important;
    font-size: 14px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    text-align: left;
    color: #fff;
}
.nav-link.nav-info-a.active>span {
    color: #00448b;
}
.nav-tabs .nav-link.nav-info-a.active:not(.dropdown-toggle):after,
.nav-tabs .nav-item.show .nav-link.nav-info-a:not(.dropdown-toggle):after {
    content: none !important;
}

.blockdigi-section {
    height: 100%;
    position: relative;
    width: 100%;
    background: #f5f6f9;
    border-radius: 15px;
}
.sec-content {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
    padding: 0 1px;
    position: relative;
    width: 100%;
    padding-bottom: 0px;
    margin-top: 0px;
}
.content-divs {
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    line-height: 30px;
}
.content-divs {
    line-height: 25px;
    padding: 7px 0px 7px 0px;
    border-bottom: solid 1px #e0e3e6;
}
.content-left-sec.hrmspayrolldesc {
    -webkit-flex: 0 0 160px;
    flex: 0 0 160px;
    font-size: 13px;
    font-weight: 500;
    line-height: 1.23;
    letter-spacing: normal;
    color: #303031;
}

.content-divs.hrmspayroll-divs {
    padding: 8px 0px 8px 0px;
    border-bottom: solid 1px transparent;
}

.content-right-sec {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-flex: 1 1 auto;
    flex: 1 1 auto;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 11px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.21;
    letter-spacing: normal;
    text-align: right;
    color: #303031;
}
.content-right-sec.hrmspayroll-right-desc {
    font-size: 13px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.23;
    letter-spacing: normal;
    text-align: left;
    color: #303031;
}

.content-left-sec.hrmspayrollbankdesc {
    -webkit-flex: 0 0 170px;
    flex: 0 0 170px;
    font-size: 13px;
    font-weight: 500;
    line-height: 1.23;
    letter-spacing: normal;
    color: #303031;
}

.content-divs.hrmspayrollbank-divs {
    padding: 5px 0px 5px 0px;
    border-bottom: solid 1px transparent;
}

.content-right-sec.hrmspayrollbank-right-desc {
    font-size: 13px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.23;
    letter-spacing: normal;
    text-align: left;
    color: #303031;
}

.header-invest {
    font-size: 16px;
    font-weight: 600;
    line-height: 1.24;
    letter-spacing: 0.73px;
}
.contacts-list-header {
    border-bottom: 1px solid #eee;
}
.vue-map {
    border-radius: 12px;
}

.qrcode-info-block {
    border-radius: 6px;
    border: solid 2px #00448b;
    background-color: #fff;
    width: 180px;
    height: 180px;
    position: relative;
    display: block;
    white-space: nowrap;
    vertical-align: bottom;
    margin: 0 auto;
    float: none;
}
.qrcode-info-content {
    text-align: center;
    margin: 4px auto;
}
.qr-info-logo {
    margin-top: 63px;
    margin-left: -17px;
    width: 50px;
    margin-bottom: 63px;
    margin-right: 0px;
    position: absolute;
}
.list-group.list-group-address .list-group-item {
    padding: 0rem !important;
    margin-bottom: 0px;
    background-color: transparent;
    border: 0px solid rgba(0,0,0,0.125);
    min-height: 5.8rem;
    line-height: 1.6rem;
    border-radius: 0px;
}
.list-group.list-group-address .list-group-item>.avatar {
    margin: 0 0.6rem 0 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Information.vue